class Main extends React.Component {
	constructor(props) {
		super(props);
	}
	componentDidMount(){
		this.resetRich()
	}
	componentDidUpdate(preProps){
		preProps.value !== this.props.value && this.resetRich()
	}
	render() {
		if (!this.check(this.props.value || "")) {
			return (<div className="csm-richcontent"/>);
		}
		return (
			<div className="csm-richcontent" dangerouslySetInnerHTML={{__html: this.props.value }} />
		)
	}
	check(value) {
		return true;
		var l = value.match(/<[^\/>]+>/g) || [];
		var r = value.match(/<\/[^>]+>/g) || [];
		return l.length == r.length;
	}
	resetRich(){
		//样式处理
		let rich = document.getElementsByClassName('csm-richcontent')[0];
		let imgs = !!rich ? document.getElementsByTagName('img') : '';
		let tables = !!rich ? rich.getElementsByTagName('table') : '';
		let tableWidth = !!rich ? rich.offsetWidth - 60 : 0;
		if(!!imgs){
			for (let i = 0; i < imgs.length; i++) {
				if(imgs[i].className == '' && imgs[i].className != 'csm-app-img'){
					imgs[i].style.width = '100%';
					imgs[i].style.height = 'auto';
				}
			}
		}
		if(!!tables){
			for (let j = 0; j < tables.length; j++) {
				tables[j].style.width = tableWidth + 'px';
				tables[j].style.fontSize = '0.26rem';
			}
		}
	}
}
export default Main;


// WEBPACK FOOTER //
// ./project/components/util/rich/RichContent.js